import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import Placeholder from '../../home/_placeholder/index';

/*
 * 各ステップの screen は実在する画面のみを指す。
 * TODO: 下記のラベルに対応する実スクリーンショットへ差し替える。
 *  - step01: サロン管理画面「3.求人票を作成しましょう」 src/salon/desktop/1.manual/3.school ( /service 要ログイン )
 *  - step02: 学校管理画面「求人情報」一覧            src/school/1.jobPostings/index.tsx ( /school/service/recruit )
 *  - step03: 学校管理画面 求人行の「推奨 / ブロック」操作 src/school/1.jobPostings/1.item/index.tsx
 *  - step04: 学生 求人検索                          src/pages/top/index.tsx ( / ) ／ 学生アプリ
 *  - step05: 学校管理画面「学生の進捗情報」          src/school/2.students/*  ※契約校向け機能
 */
const STEPS = [
  {
    no: '01',
    title: 'サロンが Web で求人を登録',
    text: 'サロンが Web 上から直接、求人情報を入力します。学校ごとに求人票を作って郵送する必要がありません。',
    screen: 'サロン側 求人票作成画面',
    note: null,
  },
  {
    no: '02',
    title: '学校が管理画面で確認',
    text: '届いた求人を一覧で確認・管理。企業名・都道府県・店舗数・卒業生数などで並べ替え・絞り込みができ、求人票 PDF はまとめてダウンロードできます。',
    screen: '学校側 求人情報一覧画面',
    note: null,
  },
  {
    no: '03',
    title: '学生へ公開',
    text: '確認した求人のうち、学生に見せたいものを「推奨」、見せないものを「ブロック」に設定します。学校が求人票を1件ずつ配らなくても、学生側に反映されます。',
    screen: '学校側 求人の推奨・ブロック設定',
    // TODO: 「公開」という表現でよいか要確認。現状のプロダクトは recommendList / blockList による表示制御。
    note: '現在のプロダクトでは「推奨 / ブロック」で学生側の表示を制御しています。',
  },
  {
    no: '04',
    title: '学生が検索・閲覧',
    text: '学生はスマートフォンから、勤務地・待遇・サロンの特徴などで求人を検索・閲覧できます。アプリのほか Web でも閲覧できます。',
    screen: '学生 求人検索・一覧画面',
    note: null,
  },
  {
    no: '05',
    title: '就職指導へ活用',
    text: '学生の進捗状況を学校側の管理画面から確認できます。',
    screen: '学校側 学生の進捗情報画面',
    // TODO: 学生の進捗情報・サロン分析は契約校向け機能。LP掲載可否・表記を要確認。
    note: '学生の進捗情報の確認は契約校向けの機能です。',
  },
];

const Flow = () => {
  return (
    <section id="flow" className={Styles.flow}>
      <SectionTitle
        pattern="B"
        title={<>求人票が届いてから、<br className={Styles.brsp} />学生が見るまでを一本化</>}
        lead="求人票の受け取り・確認・学生への公開・閲覧までを、ひとつの流れにまとめます。（画像は実際のサービス画面に差し替え予定です）"
      />

      <div className={Styles.rows}>
        {STEPS.map((s, i) => (
          <div key={s.no} className={`${Styles.row} ${i % 2 === 1 ? Styles.rowAlt : ''}`}>
            <div className={Styles.shot}>
              <span className={Styles.shotTag}>{s.screen}</span>
              {/* TODO: {s.screen} の実スクリーンショットに差し替え */}
              <Placeholder label={s.screen} height={220} />
            </div>
            <div className={Styles.text}>
              <span className={Styles.no}>{s.no}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
              {s.note && <p className={Styles.note}>※ {s.note}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Flow;
